/* eslint-disable @typescript-eslint/no-unused-vars */
import deepmerge from 'deepmerge';
import { ShellProps } from '../../typings';
import isFunction from '../../helpers/is-function';

export default async (
  { config, files }: ShellProps & { files: any },
  cb?: any
) => {
  const loadedSsrModules = await files?.reduce(
    async (modulePromise, { moduleName, files: componentFiles }) => {
      return modulePromise.then(async result => {
        const loadedModule = await componentFiles?.reduce(
          async (componentPromise, componentFile) => {
            return componentPromise.then(async moduleResult => {
              const componentName = componentFile?.component;
              const ssr = componentFile?.ssr;
              if (!ssr) return Promise.resolve(moduleResult);

              if (ssr && isFunction(ssr)) {
                const loadedSsrComponent = (await ssr()).default;
                const componentMappedToModule = []
                  .concat(componentName)
                  .reduce((acc, comp) => {
                    return deepmerge(acc, {
                      [moduleName]: {
                        [comp]: loadedSsrComponent
                      }
                    });
                  }, {});

                return Promise.resolve(
                  deepmerge(moduleResult, componentMappedToModule)
                );
              }

              return Promise.resolve(moduleResult);
            });
          },
          Promise.resolve({})
        );

        return Promise.resolve(deepmerge(result, loadedModule));
      });
    },
    Promise.resolve({})
  );

  return loadedSsrModules;
};
